/* Built In Imports */
import NextLink from 'next/link';

/* External Imports */
import { Box, Divider, Flex, Link, Text } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
/* Services */

/**
 *Render Error 404 Component
 * @returns {ReactElement} Error404 component
 */
const Error404 = () => {
  return (
    <>
      <Flex w="100%" flexWrap="wrap" pos="relative" marginTop="20px">
        <Box
          w={{
            base: '100%',
            sm: '100%',
            md: '100%',
            lg: '100%',
          }}
        >
          <Box>
            <Text
              fontFamily="FedraSansStd-medium"
              fontSize={{ base: '145px', sm: '145px', md: '300px' }}
              textAlign="center !important"
              letterSpacing="-12.4px"
              color="#aea493"
              lineHeight="1"
              marginBottom="55px"
            >
              404
            </Text>
            <Text
              fontFamily="FedraSansStd-medium"
              fontSize={{ base: '16px', sm: '16px', md: '20px' }}
              fontWeight="500"
              textAlign="center !important"
              color="#cf4520"
              lineHeight="{{base:'1.72',sm:'1.72',md:'1.55'}}"
              marginLeft="{{base:'10%',sm:'10%',md:'2%'}}"
              paddingBottom="20px"
            >
              A wise man once asked…
            </Text>
            <Text
              fontFamily="FedraSansStd-book-i"
              fontSize={{ base: '21px', sm: '21px', md: '27px' }}
              fontWeight="500"
              textAlign="center !important"
              color="#28231e"
              lineHeight="1.35"
              marginLeft="2%"
              paddingBottom="20px"
            >
              If you’ve come to a page that can not be found Does it actually
              exist?
            </Text>
            <Divider orientation="horizontal" />
            <Box textAlign="center" marginTop="40px" paddingBottom="100px">
              <NextLink href="/" prefetch={false} passHref legacyBehavior>
                <Link>
                  <Box
                    fontFamily="FedraSansStd-medium"
                    background="#cf4520"
                    paddingBottom="140px"
                    color="#faf7f0"
                    fontWeight="500"
                    fontSize={{ base: '13px', sm: '13px', md: '13px' }}
                    padding={{ base: '10px 23px 9px', sm: '10px 23px 9px' }}
                    display="inline"
                    border="none"
                    borderRadius="5px"
                    _hover={{
                      border: 'none',
                      color: '#ffffff',
                      background: '#000054',
                    }}
                    _active={{
                      border: 'none',
                      background: '#000054',
                    }}
                    cursor="pointer"
                  >
                    Home
                  </Box>
                </Link>
              </NextLink>
            </Box>
          </Box>
        </Box>
      </Flex>
    </>
  );
};

export default Error404;
